import CurrenciesList from "../../assets/json/currencies.json";

export const currencyConstants = {
  GET_CURRENCY_LIST_START: "GET_CURRENCY_LIST_START",
  GET_CURRENCY_LIST_SUCCESS: "GET_CURRENCY_LIST_SUCCESS",
  GET_CURRENCY_LIST_ERROR: "GET_CURRENCY_LIST_ERROR",
  CLEAR_CURRENCY_LIST: "CLEAR_CURRENCY_LIST"
};

export function getCurrencyList() {
  return (dispatch) => {
    dispatch({
      type: currencyConstants.GET_CURRENCY_LIST_START
    });

    return new Promise((resolve, reject) => {   
      try {   
        dispatch({ type: currencyConstants.GET_CURRENCY_LIST_SUCCESS, payload: CurrenciesList });
        resolve(CurrenciesList);
      } catch (e){
        dispatch({ type: currencyConstants.GET_CURRENCY_LIST_ERROR });
        reject();
      }
      /* fetch("https://utilitiesdevwe.blob.core.windows.net/json/currency.json")
        .then((serverPromise) => {
          serverPromise
            .json()
            .then((data) => {
              dispatch({ type: currencyConstants.GET_CURRENCY_LIST_SUCCESS, payload: data });
              resolve(data);
            })
            .catch((e) => {
              dispatch({ type: currencyConstants.GET_CURRENCY_LIST_ERROR });
              reject();
            });
        })
        .catch((e) => {
          dispatch({ type: currencyConstants.GET_CURRENCY_LIST_ERROR });
          reject();
        });*/
    });
  };
}
